import * as React from 'react';

function ChevronLeftIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6237 3.4594C13.2331 3.06887 12.6 3.06887 12.2094 3.4594L6.3759 9.29293C5.98538 9.68346 5.98538 10.3166 6.3759 10.7071L12.2094 16.5407C12.6 16.9312 13.2331 16.9312 13.6237 16.5407C14.0142 16.1502 14.0142 15.517 13.6237 15.1265L8.49722 10L13.6237 4.87361C14.0142 4.48309 14.0142 3.84992 13.6237 3.4594Z"
        className="fill-icn-txt-prim"
      />
    </svg>
  );
}

export default ChevronLeftIcon;
